function removeParams (text: string) {
  return text?.split('?')?.[0]
};

export default removeParams
